/*
 Created by CHT 2020/1/14 11:32
*/

export function UPDATE__APP_ID (state, appId) {
  state.appId = appId
}

export function UPDATE__APP (state, app) {
  state.activeApp = app
}

export function UPDATE__FORM_ID (state, formId) {
  state.formId = formId
}

export function UPDATE__COMPANY_ID (state, companyId) {
  state.companyId = companyId
}

export function UPDATE__USER_ID (state, userId) {
  state.userId = userId
}

export function UPDATE__TOKEN (state, token) {
  state.token = token
}

export function UPDATE__USER_INFO (state, userInfo) {
  state.userInfo = userInfo
}

export function UPDATE__COMPANY (state, company) {
  state.company = company
}

export function UPDATE_COMPANY_LIST(state, list) {
  state.companyList = list || []
}

export function UPDATE_TENANT_KEY(state, tenantKey) {
  state.tenantKey = tenantKey
}

// 更新用户list
export function UPDATE_USER_LIST(state, userList) {
  let current = null
  let list = userList.filter(userInfo => {
    if (state.userInfo && state.userInfo.userId === userInfo.userId) {
      current = userInfo
      return false
    } else {
      return true
    }
  })
  if (current) list.unshift(current)
  state.userList = list
}

export function UPDATE_LEAVE_MEMBER_LIST(state, leaveMemberList) {
  state.leaveMemberList = leaveMemberList || []
}

export function UPDATE_LEAVE_EXTERNAL_LIST(state, leaveExternalList) {
  state.leaveExternalList = leaveExternalList || []
}

// 更新角色list
export function UPDATE_ROLE_LIST(state, roleList) {
  state.roleList = roleList || []
}

// 更新组织架构信息
export function UPDATE_ORGANIZATION(state, organization) {
  state.organization = organization || {}
}


// 更新外部联系人列表
export function UPDATE_EXTERNAL_LIST(state, list) {
  this.state.externalList = list || []
}

// 更新外部联系人标签列表
export function UPDATE_EXTERNAL_LABEL_LIST(state, list) {
  this.state.extLabelList = list || []
}

// 更新外部联系人标签列表
export function UPDATE_CAN_NAV_BACK(state, canNavBack) {
  this.state.canNavBack = canNavBack
}

export function UPDATE_ADMIN(state, admin) {
  state.adminInfo = admin
}

// 系统配置
export function SET_SYSTEM_CONFIG(state, systemConfig) {
  state.systemConfig = systemConfig
}

// 个性化配置
export function SET_PERSONALIZED_CONFIG(state, personalizedConfig) {
  state.personalizedConfig = personalizedConfig
}

export function UPDATE_ENV(state, env) {
  state.env = env
}

export function UPDATE_OPENID(state, openId) {
  state.openId = openId
}

export function SET_SHOW_DRAGGABLE(state, showDraggable) {
  state.showDraggable = showDraggable
}

export function SET_SHOW_BACK(state, showBack) {
  state.showBack = showBack
}

export function SET_SPACE_PAGES(state, spacePages) {
  state.spacePages = spacePages
}

export function SET_LOGIN_DRAGGABLE(state, showLoginDraggable) {
  state.showLoginDraggable = showLoginDraggable
}

export function SET_YMT_NODEKEY(state, ymtNodeKey) {
  state.ymtNodeKey = ymtNodeKey
}
export function SET_YMT_QRCODE(state, ymtQrcode) {
  state.ymtQrcode = ymtQrcode
}

export function UPDATE_DEP_INFO(state, depInfo) {
  state.depInfo = depInfo || {}
}

export function UPDATE_USER_MAP(state, memberDetailMap) {
  Object.assign(state.memberDetailMap, memberDetailMap)
}

export function UPDATE_EXTERNAL_MAP(state, externalDetailMap) {
  Object.assign(state.externalDetailMap, externalDetailMap)
}

export function SET_PAGE_TITLE(state, pageTitle) {
  state.pageTitle = pageTitle
}